import React, { useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';

import Lampara from './Lampara';

function Lamparas() {
  const z = useFetch('https://www.fabrilum.com.ar/backend/getLamparas.php');
  return (
    <div className="w-5/6 px-4 m-auto pt-24 ">
      <p className="font-extralight text-2xl border-solid mb-4 border-t-2 py-4 border-gray-100">
        Explorar por tipo de lampara
      </p>
      <div className="flex w-full flex-wrap justify-between">
        {z.data &&
          z.data[0].map((zoc, i) => {
            return (
              <Lampara data={zoc} index={i} delay={`delay-${i * 100 + 100}`} />
            );
          })}
      </div>
    </div>
  );
}
export default Lamparas;
